import JSPDF from 'jspdf';
import i18n from '../i18n';
import moment from 'moment';

export const generatePDF = (paymentDetails: any) => {
    // Create a new jsPDF instance
    const pdf = new JSPDF();

    const logoImg = './0a6e5c81-7861-485a-9546-c00537c6ae9a.jpeg';
    pdf.addImage(logoImg, 'JPEG', 15, 10, 30, 10);

    // Set font
    pdf.setFont('Helvetica', 'normal');

    // Add double-line border around the entire page
    pdf.setLineWidth(2);
    pdf.rect(5, 5, 200, 287);

    // Add background color to the title
    pdf.setFillColor(3, 120, 151);
    pdf.rect(7, 7, 196, 20, 'F');

    // Set title text color
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(24);
    pdf.text(i18n.t('invoice.title', 'SEVA Invoice'), 105, 20, { align: 'center' });

    // Set text color back to black
    pdf.setTextColor(0, 0, 0);

    // Add horizontal line
    pdf.setLineWidth(0.5);

    // Format date cleanly based on active language (e.g., "27/10/2026" or "October 27, 2026")
    let formattedDate = "-";
    if (paymentDetails?.date) {
        const m = moment(paymentDetails.date);
        if (m.isValid()) {
            const currentLang = i18n.language || "fr";
            formattedDate = currentLang.startsWith("en")
                ? m.format("MMMM DD, YYYY")
                : m.format("DD/MM/YYYY");
        } else {
            formattedDate = String(paymentDetails.date);
        }
    } else {
        formattedDate = moment().format("DD/MM/YYYY");
    }

    const amountNum = Number(paymentDetails?.amount) || 0;
    const formattedAmount = `CHF ${amountNum.toFixed(2)}`;

    // Add payment details with improved styling
    pdf.setFontSize(14);
    pdf.text(`${i18n.t('invoice.programName', 'Program Name:')} ${paymentDetails?.programName || '-'}`, 20, 50);
    pdf.text(`${i18n.t('invoice.date', 'Date:')} ${formattedDate}`, 20, 60);
    pdf.text(`${i18n.t('invoice.amount', 'Amount:')} ${formattedAmount}`, 20, 70);
    pdf.text(`${i18n.t('invoice.refId', 'Payment Reference Id:')} ${paymentDetails?.paymentReferenceId || '-'}`, 20, 80);

    // Add a decorative line
    pdf.setLineWidth(0.3);

    // Add a thank you message
    pdf.setFontSize(17);
    pdf.text(i18n.t('invoice.thankYou', 'Thank you for your payment!'), 105, 255, { align: 'center' });

    // Add the health-related tagline wrapped nicely inside page margins
    pdf.setFontSize(10.5);
    pdf.setTextColor(80, 80, 80);
    const tagline = i18n.t('invoice.tagline', "Empower your life with our health programs - because a healthy you is a wealthy you.");
    const wrappedTagline = pdf.splitTextToSize(tagline, 160);
    pdf.text(wrappedTagline, 105, 272, { align: 'center' });

    // Save the PDF
    const filePath = 'payment_receipt.pdf';
    pdf.save(filePath);

    console.log(`Attractive payment receipt saved to ${filePath}`);
};
